import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-6 md:mb-8"
          >
            Leader en distribution de dispositifs médicaux en Algérie
          </motion.h2>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="space-y-4 md:space-y-6 text-base md:text-lg text-[#4A4A4A] leading-relaxed"
          >
            <p>
              ADF Biomédical est un acteur spécialisé dans la distribution de dispositifs médicaux destinés aux hôpitaux et cliniques algériens. Notre approche repose sur la qualité, la conformité et la fiabilité des solutions proposées.
            </p>
            <p>
              Nous nous engageons à fournir des équipements médicaux de haute qualité répondant aux besoins spécifiques des professionnels de santé et contribuant à l'amélioration des soins aux patients.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-8 md:mt-10"
          >
            <Link
              to="/about"
              className="inline-flex items-center text-[#E31B23] font-medium hover:text-[#C41820] transition-colors duration-300 cursor-pointer text-base md:text-lg"
            >
              En savoir plus
              <i className="ri-arrow-right-line ml-2 text-xl"></i>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
